<template>
  <div class="tk-toolbar">
    <button
      type="button"
      class="tk-btn"
      :class="{ 'tk-btn--aktif': locked }"
      :disabled="!lockable"
      @click="$emit('lock')"
    >
      <i :class="locked ? 'ri-lock-fill' : 'ri-lock-unlock-line'"></i>
      <span>{{ locked ? 'Y axis locked' : 'Lock Y axis' }}</span>
    </button>

    <button v-if="zoomed" type="button" class="tk-btn" @click="$emit('reset')">
      <i class="ri-zoom-out-line"></i>
      <span>Reset zoom</span>
    </button>

    <span class="tk-pisah"></span>

    <button type="button" class="tk-btn" :disabled="!exportable" @click="$emit('png')">
      <i class="ri-image-line"></i>
      <span>PNG</span>
    </button>

    <button type="button" class="tk-btn" :disabled="!exportable" @click="$emit('csv')">
      <i class="ri-file-list-2-line"></i>
      <span>CSV</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ChartToolbar',
  props: {
    locked: { type: Boolean, default: false },
    zoomed: { type: Boolean, default: false },
    lockable: { type: Boolean, default: true },
    exportable: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.tk-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 14px;
  margin-bottom: 2px;
  padding-top: 10px;
  border-top: 2px solid var(--mz-border);
}
.tk-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  font-size: var(--mz-fs-sm);
  font-weight: 500;
  line-height: 1.4;
  color: var(--mz-text-subtle);
  background: transparent;
  border: 1px solid var(--mz-border);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
}
.tk-btn:hover {
  color: var(--mz-text-emphasis);
  background: var(--mz-neutral-light-bg);
  border-color: var(--mz-border-strong);
}
.tk-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.tk-btn:disabled:hover {
  color: var(--mz-text-subtle);
  background: transparent;
  border-color: var(--mz-border);
}
.tk-btn:active {
  background: var(--mz-neutral-dark-bg);
}
.tk-btn:focus-visible {
  outline: 2px solid var(--mz-focus);
  outline-offset: 1px;
}
.tk-btn i {
  font-size: var(--mz-fs-base);
  line-height: 1;
}
.tk-btn--aktif {
  color: #1d4ed8;
  background: #eff6ff;
  border-color: #bfdbfe;
}
.tk-btn--aktif:hover {
  background: #dbeafe;
  border-color: #93c5fd;
}
.tk-pisah {
  width: 1px;
  height: 18px;
  background: var(--mz-neutral-dark-bg);
  margin: 0 2px;
}
</style>
